<template>
    <v-list-item
            avatar
    >
        <v-list-item-avatar>
            <img :src="avatar">
        </v-list-item-avatar>

        <v-list-item-content>
            <v-list-item-title v-html="user.user_name || `${user.first_name} ${user.last_name || user.last_names[0]}.`"></v-list-item-title>
            <v-list-item-subtitle v-html=""></v-list-item-subtitle>
        </v-list-item-content>
    </v-list-item>
</template>

<script>
    import {getFakeAvatar} from '@/utils/Common'
    export default{
        props: ['user'],
        computed:{
            avatar(){

                var vm = this
                return vm.user.avatar || getFakeAvatar(vm.user.gender)

            },
            from(){

            }
        }

    }
</script>
